// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"8edb9256","372":"e7d8af67","448":"54d7fb89","630":"b4fb365b","856":"7e1f9062","858":"30ff0bc9"}[chunkId] + ".chunk.js";
};